// webform-floating-labels.js
// Handles adding a .has-value class when inputs contain text.
// This works around an autoprefixer bug where :not(:placeholder-shown)
// generated :-moz-placeholder which broke floating labels on Firefox.
(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.webformFloatingLabels = {
    attach(context) {
      const inputs = once(
        'webform-floating-labels',
        '#app form input:not([type="submit"]):not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), #app form textarea',
        context
      );

      const updateHasValueClass = (input) => {
        if (input.value && input.value.trim() !== '') {
          input.classList.add('has-value');
        } else {
          input.classList.remove('has-value');
        }
      };

      inputs.forEach(input => {
        // Initial check
        updateHasValueClass(input);

        // Listen for input and change events
        input.addEventListener('input', () => updateHasValueClass(input));
        input.addEventListener('change', () => updateHasValueClass(input));
      });
    }
  };
})(Drupal, once);
